import React from "react";

// Local Imports
import "./style.css"

function Footer() {

    return (
        <footer>
            <h4 className="FooterText">
                Created by Nishkarsh. 
                <br/>React School. 
                <br/>Trained by Ishaan.
            </h4>
        </footer>
    );
}

export default Footer;